<template>
  <div class="funnels__content" v-if="stepData">
    <div class="scroll_content" ref="scrollContent">
      <div class="funnel__regist--wrap">
        <ui-button
          circle
          iconName="icon--inflow__back"
          @click.prevent="$router.push({ name: 'funnel.view', params: { aid: $route.params.aid, fid: $route.params.fid, timezoneName: applyData.timezoneName, device: $route.params.device, faid: $route.params.faid }, query: { timezoneName: applyData.timezoneName, device: $route.query.device, faid: $route.query.faid } })"
          class="link_backpage">
        </ui-button>
        <span class="txt_desc">{{ isConverted ? 'Converted' : isDropped ? 'Dropped' : 'Inflow' }}</span>
        <h2 class="title">Step {{ seq + 1 }}</h2>
        <strong class="txt_emph">{{ stepData.name }}</strong>
        <span class="txt_url">{{ stepData.url }}</span>
      </div>

      <div class="wrap_table wrap_table2" ref="listTable"
        @mouseenter="$refs.listTable.classList.add('wrap_table2')"
        @mouseleave="$refs.listTable.classList.remove('wrap_table2')">
        <!--  hover시 wrap_table2 클래스 사용  -->
        <app-pagination class="clearfix"
          :total="total"
          :page="page"
          :limit="limit"
          @onPagingOptionChange="onPagingOptionChange">
          <template v-slot:filter>
            <a href="#none" class="btn_filter"
              @click.prevent="showFilter = true">
              <span class="icon icon--filter"></span>
              {{ $t('common.filter') }}
            </a>
          </template>
        </app-pagination>

        <table>
          <colgroup>
            <col style="width:120px">
            <col style="width:120px">
            <col style="width:*">
            <col style="width:93px">
            <col style="width:90px">
            <col style="width:78px">
            <col style="width:55px">
            <col style="width:87px">
            <col style="width:88px">
            <col style="width:95px">
          </colgroup>
          <thead>
          <tr>
            <th>
              <sort-options
                columnName="sessId"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.sessionId')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="existing"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.userType')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="cvr"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.nextPage')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="country"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.location')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="sessTime"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.visitDuration')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="device"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.device')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="os"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.os')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="browser"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.browser')"></span>
              </sort-options>
            </th>
            <th>
              <sort-options
                columnName="date"
                :sortColumn="sortColumn"
                :isSortAsc="isSortAsc"
                @onSortOptionChange="onSortOptionChange">
                <span v-html="$t('common.table.header.date')"></span>
              </sort-options>
            </th>
            <th>
              <span v-html="$t('common.report')"></span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="txt-left data__sess-id">
              <div class="inner_cell">{{ item.sessId }}</div>
            </td>
            <td>
              <template v-if="item.existing === true">{{ $t('common.revisit') }}</template>
              <template v-else-if="item.existing === false">{{ $t('common.new') }}</template>
              <template v-else>{{ $t('common.noData') }}</template>
            </td>
            <td class="txt-left data__cvr">
                  <span class="text--wrap">
                    <ui-icon-tooltip v-if="item.cvrFail" arrowCenter arrowBottom>
                      <div>
                        <p class="title">{{ $t('funnel.sessionList.cvrFail.title') }}</p>
                        <ul class="list">
                          <li class="reason">{{ $t('funnel.sessionList.cvrFail.reason1') }}</li>
                          <li class="reason">{{ $t('funnel.sessionList.cvrFail.reason2') }}</li>
                          <li class="reason">{{ $t('funnel.sessionList.cvrFail.reason3') }}</li>
                        </ul>
                      </div>
                    </ui-icon-tooltip>
                    <span class="item-text ellipsis">{{ getCvr(item) }}</span>
                  </span>
            </td>
            <td>
              <country-flag :countryCode="item.country"/>
            </td>
            <td>{{ item.sessTime | milliSeconds }}</td>
            <td class="data__device">
              <i class="icon" :class="`icon--${item.device}`">
                <ui-icon-tooltip v-if="item.device === 'tablet'" arrowBottom arrowRight>
                  {{ $t('funnel.sessionList.NotSupportTablet') }}
                </ui-icon-tooltip>
              </i>
            </td>
            <td>
                  <span class="icon icon--os"
                        :class="item.os | osIconName"
                        :title="item.os"></span>
            </td>
            <td>
                  <span class="icon icon--browser"
                        :class="item.browser | browserIconName"
                        :title="item.browser"></span>
            </td>
            <td class="data__date">{{ item.date | dateFormatTimezone(userData.timezoneName, 'YYYY-MM-DD HH:mm:ss') }}</td>
            <td>
              <ui-button
                class="btn_item"
                size="small"
                iconName="icon--dashboard-confirm"
                :disabled="item.device === 'tablet'"
                @click="onOpenSessionReport(item)">
                {{ $t('common.view') }}
              </ui-button>
            </td>
          </tr>
          <!-- 테이블에 데이터 없을시 사용 -->
          <!-- <tr>
            <td colspan="10">
              <span class="txt_desc">
                <span class="icon icon--session"></span>
                Session Report does not exist.
              </span>
            </td>
          </tr>-->
          </tbody>
        </table>
      </div>
      <back-to-top refName="scrollContent"/>
    </div>

    <funnels-session-filter v-if="showFilter && filterOptions"
      :showFilter.sync="showFilter"
      :currentFilter="currentFilter"
      :filterOptions="filterOptions"
      @onCancelClick="onCancelFilterClick"
      @onApplyClick="onApplyFilterClick"/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { parse, format, isValid, isBefore } from 'date-fns'
import { getFunnelStream, getReport } from '@/api/funnel'
import { upperFirst, utcToLocalTimezone } from '@/libs/utils'
import AppPagination from '@/components/ui/AppPagination'
import BackToTop from '@/components/ui/BackToTop'
import FunnelsSessionFilter from './FunnelsSessionListFilter'
import CountryFlag from '@/components/ui/CountryFlag'
import UiButton from '@/components/ui/UiButton'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import SortOptions from '@/components/ui/SortOptions'
import store from '@/store'

function getDefaultFilter () {
  return {
    cvr: '',
    sessionId: '',
    existing: '',
    country: '',
    device: '',
    os: '',
    browser: '',
    sessionGteTime: 0,
    sessionLteTime: null
  }
}

export default {
  name: 'FunnelSessionList',
  components: {
    AppPagination,
    BackToTop,
    FunnelsSessionFilter,
    CountryFlag,
    UiButton,
    UiIconTooltip,
    SortOptions
  },
  props: [
    'rawData'
  ],
  data () {
    return {
      items: [],
      filterOptions: null,
      showFilter: false,
      currentFilter: getDefaultFilter(),
      total: 0,
      page: 1,
      limit: 30,
      sortColumn: 'date',
      isSortAsc: false,
      funnelData: null
    }
  },
  computed: {
    ...mapState([
      'userData',
      'applyData',
      'reportPeriod'
    ]),
    seq () {
      return Number(this.$route.query.seq)
    },
    isDropped () {
      return this.$route.query.dropped === 'true' || this.$route.query.dropped === true
    },
    isConverted () {
      return this.$route.query.converted === 'true' || this.$route.query.converted === true
    },
    sortOrder () {
      let value = this.sortColumn

      if (!this.isSortAsc) {
        value = `-${value}`
      }
      return value
    },
    stepData () {
      return this.rawData ? this.rawData.funnelList[this.seq] : this.funnelData.funnelList[this.seq]
    },
    nextPage () {
      const funnelList = this.rawData.funnelList
      let nextPage = null

      if (funnelList[this.seq + 1]) {
        nextPage = funnelList[this.seq + 1].url
      }
      return nextPage
    }
  },
  watch: {
    reportPeriod (newValue, oldValue) {
      if (newValue.isFunnelMinSet === oldValue.isFunnelMinSet) { // if just min date has changed, pass
        this.loadData()
      }
    }
  },
  async created () {
    this.loadData()
  },
  methods: {
    ...mapMutations([
      'setReportPeriod',
      'setFunnelData'
    ]),
    computedDate (value) {
      return format(utcToLocalTimezone(value, this.applyData.timezoneName), 'YYYY-MM-DD HH:mm:ss')
    },
    loadData () {
      const fid = this.$route.params.fid

      const apiParams = {
        fid,
        timezoneName: this.userData.timezoneName,
        seq: this.seq || 0,
        startDate: this.reportPeriod.start,
        endDate: this.reportPeriod.end,
        dropped: this.isDropped,
        page: this.page,
        itemNum: this.limit,
        order: this.sortOrder
      }

      if (this.filterOptions) {
        for (let [key, value] of Object.entries(this.currentFilter)) {
          let useOption = false

          if (typeof value === 'string') {
            value = value.trim()
          }

          if (['sessionGteTime', 'sessionLteTime'].includes(key)) {
            if (key === 'sessionGteTime' && value > 0) {
              useOption = true
            } else if (key === 'sessionLteTime' && value !== null) {
              useOption = true
            }
          } else if (value !== '') {
            useOption = true
          }

          if (useOption) {
            apiParams[key] = value
          }
        }
      }

      getFunnelStream(apiParams).then(data => {
        this.items = data.funnelSessions.list
        this.total = data.funnelSessions.count
        this.filterOptions = data.filterOptions[0]
      }).catch(err => {
        console.error(err)
      })
    },
    onCancelFilterClick () {
      this.currentFilter = getDefaultFilter()
    },
    onApplyFilterClick (filter) {
      this.currentFilter = filter
      this.showFilter = false
      this.page = 1
      this.loadData()
    },
    getCvr (item) {
      let cvrUrl = ''
      if (this.isDropped) {
        if (!item.cvrFail && item.cvr) {
          cvrUrl = item.cvr
        } else {
          // todo: i18n check ja
          cvrUrl = this.$t('common.exit')
        }
      } else {
        if (item.realCvr) {
          cvrUrl = item.realCvr
        } else {
          cvrUrl = item.cvrFail ? this.nextPage : item.cvr
        }
      }
      if (cvrUrl === this.$t('common.exit').toLowerCase()) {
        return upperFirst(cvrUrl)
      }
      return cvrUrl
    },
    onPagingOptionChange (page, limit) {
      this.page = page
      this.limit = limit
      this.loadData()
    },
    onSortOptionChange (column, isAsc) {
      if (this.sortColumn === column && this.isSortAsc === isAsc) {
        return
      }
      this.sortColumn = column
      this.isSortAsc = isAsc
      this.$nextTick().then(() => {
        this.page = 1
        this.loadData()
      })
    },
    onOpenSessionReport (session) {
      const aid = this.stepData.aid
      // const sid = this.rawData.sid
      const startDate = this.reportPeriod.start
      const endDate = this.reportPeriod.end
      const device = session.device
      const seq = session.sessSeq
      const ssid = session.sessId
      const url = encodeURIComponent(this.stepData.url)
      const pageName = encodeURIComponent(this.stepData.name)
      const timezoneName = encodeURIComponent(this.applyData.timezoneName)
      const uEndDate = format(parse(session.date), 'YYYY-MM-DD')

      const to = {
        name: 'funnel.session',
        query: {
          aid,
          startDate,
          endDate,
          device,
          seq,
          ssid,
          uEndDate,
          url,
          pageName,
          timezoneName
        }
      }
      const href = this.$router.resolve(to).href
      // window.open(`${OLD_BEUSABLE_HOST}/tool/stream?${query}`, '_blank')
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.funnels__content {
  overflow-x: auto;

  .funnel__regist--wrap {
    width: 100%;
    display: flex;
    padding-left: 10px;
    align-items: center;
    box-sizing: border-box;
    .link_backpage {
      margin-right: 15px;
    }
    .txt_desc {
      font-size: 22px;
      color: #43b6c9;
      &:after {
        content: "";
        display: inline-block;
        margin: 0 8px;
        width: 5px;
        height: 5px;
        background-color: #c1c1c1;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
    .title {
      display: inline-block;
      font-size: 22px;
      color: #444;
      &:after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 12px;
        margin: 0 15px;
        background-color: #d7d7d7;
      }
    }
    .txt_emph {
      font-size: 22px;
      color: #444;
    }
    .txt_url {
      display: inline-block;
      font-size: 16px;
      color: #444;
    }
    .txt_emph + .txt_url {
      padding-left: 15px;
    }
    .btn_register {
      margin-left: auto;
      height: 38px;
      padding: 0 13px;
      line-height: 38px;
      border-radius: 20px;
      box-shadow: 0 12px 13px -6px rgba(0, 0, 0, 0.15);
      background-color: #ec0047;
      color: #fff;
      font-size: 14px;
      .icon--plus-white {
        display: inline-block;
        margin: 12px 9px 0 0;
        vertical-align: top;
      }
    }
  }
  .wrap_table {
    position: relative;
    margin-top: 18px;
    padding: 20px 20px 30px 20px;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08),
      0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    min-width: 930px;

    table {
      width: 100%;

      thead tr {
        height: 50px;
        background-color: #555555;
        font-weight: bold;
        line-height: 1.23;
        color: #ffffff;
        text-align: center;

        th {
          white-space: nowrap;
        }

        th.clickable { cursor: pointer; }

        th:nth-of-type(1){
          position: relative;
          &:before {
            content: '';
            display: inline-block;
            width: 15px;
            height: 50px;
            position: absolute;
            top: 0;
            left: -5px;
            background-color: #555;
            border-radius: 5px;
          }
          &.align-left {
            text-align: left;
            padding-left: 10px;
          }
        }
        th:nth-last-of-type(1) {
          position: relative;
          &:after {
            content: '';
            display: inline-block;
            width: 10px;
            height: 50px;
            position: absolute;
            top: 0;
            right: -5px;
            background-color: #555;
            border-radius: 5px;
          }
        }

        span {
          position: relative;
          display: inline-block;
          .icon {
            position: absolute;
            top: 50%;
            right: -19px;
            transform: translateY(-50%);
          }
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #ebebeb;
          td {
            height: 80px;
            font-size: 14px;
            line-height: 14px;
            text-align: center;
            color: #2f2f2f;

            &.data__sess-id {
              font-weight: bold;
            }

            &.data__cvr {
              position: relative;
              .item-text {
                width: calc(100vw - 1100px) !important;
                min-width: 200px;
              }
              .tooltip {
                margin-right: 5px;

                /deep/ .icon {
                  width: 16px;
                  height: 16px;
                  background-image: url(../../assets/img/funnel/funnel_stop_icon.svg);

                  &:hover:after {
                    background-color: transparent;
                  }
                }

                .title {
                  font-size: 13px;
                  color: #e60724;
                  text-align: left;
                }
                .list {
                  margin-top: 4px;
                  text-align: left;
                  .reason {
                    position: relative;
                    font-size: 12px;
                    color: #444444;
                    margin-top: 8px;
                    padding-left: 7px;
                    box-sizing: border-box;

                    &:before {
                      content: '';
                      display: inline-block;
                      width: 2px;
                      height: 2px;
                      background-color: #444;

                      position: absolute;
                      top: calc(50% - 2px);
                      left: 0;
                      transform: translateY(-50%);
                    }
                  }
                }
              }
              .tooltip + .item-text {
                width: calc(100% - 37px);
              }
            }

            &.data__device {
              & > .icon {
                position: relative;
              }
              .tooltip {
                position: absolute;
                top: 50%;
                right: 0px;
                transform: translateY(-50%);

                /deep/ .icon {
                  width: 16px;
                  height: 16px;
                  background-image: url(../../assets/img/funnel/funnel_stop_icon.svg);
                  padding-right: 11px;

                  &:hover:after {
                    background-color: transparent;
                  }
                }

                /deep/ .bubble {
                  right: 0 !important;
                }
              }
            }

            &.data__date {
              font-size: 13px;
              line-height: 1.38;
              color: #666666;

              .item-text {
                display: inline-block;
                min-width: 70px;
              }
            }

            .inner_cell {
              position: relative;
              margin-left: 10px;
            }
            .text--wrap {
              position: relative;
              padding-left: 15px;
              line-height: 16px;
              box-sizing: border-box;

              .item-text {
                display: inline-block;
                width: calc(100% - 15px);
              }
            }
            .icon_item {
              width: 26px;
              height: 26px;
              background-color: #fff;
              border-radius: 50%;
            }
            .color-green {
              color: #57ab00;
            }
            .color-blue {
              color: #43b6c9;
            }
            .color-red {
              color: #ec0047;
            }
            .btn_item {
              border: solid 1px #57ab00;
              color: #4a8500;
              background-color: #fff;
              /*padding: 0 10px;
              line-height: 32px;
              border-radius: 20px;
              font-size: 13px;*/
              .icon--dashboard-confirm {
                /*vertical-align: middle;*/
              }
              &:hover {
                /*@include hoverStyle;*/
              }
            }
            .btn_item.disabled {
              /*opacity: 0.2;
              pointer-events: none;*/
            }
          }
        }
        tr:hover {
          background-color: #e6e6e6;
        }
      }
    }
  }
  .wrap_table2 {
    .tbl {
      tbody {
        tr {
          &:hover {
            background-color: transparent;
          }
        }
        td {
          .txt_desc {
            display: block;
            padding: 93px 0;
          }
          .icon--session {
            margin: 0 auto;
            display: block;
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  .in-ready {
    top: -20px;
    position: absolute;
    @include positionXcenter;
    white-space: nowrap;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16);
    background-color: #1199af;
    color: #fff;
    font-size: 12px;
    text-align: center;
    padding: 6px 10px;
    border-radius: 4px;

    &:after {
      content: '';
      background-color: #1199af;
      position: absolute;
      z-index: -1;
      width: 10px;
      height: 10px;
      bottom: 0px;
      left: 50%;
      transform: rotate(-45deg) translateX(-50%);
    }
  }
}
</style>
